<div class="info-page">
  <h3>Irfe - {{ actionLabel }} </h3>
</div>
<form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Objeto: <sup class="text-danger">*</sup></label>
      <textarea id="ds_object" class="form-control" rows="3" formControlName="ds_object"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_object')" [erros]="fieldErros('ds_object')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Público-alvo: <sup class="text-danger">*</sup></label>
      <textarea id="ds_target" class="form-control" rows="3" formControlName="ds_target"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_target')" [erros]="fieldErros('ds_target')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Concedente: <sup class="text-danger">*</sup></label>
      <textarea id="ds_object" class="form-control" rows="3" formControlName="ds_grantor"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_grantor')" [erros]="fieldErros('ds_grantor')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Convenente: <sup class="text-danger">*</sup></label>
      <textarea id="ds_object" class="form-control" rows="3" formControlName="ds_convenient"></textarea>
      <app-field-message [field]="fieldMessageRequired('ds_convenient')" [erros]="fieldErros('ds_convenient')"></app-field-message>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Data de início de vigência: <sup class="text-danger">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('dt_start')" [erros]="fieldErros('dt_start')"></app-field-message>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Data de término da vigência: <sup class="text-danger">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_end" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('dt_end')" [erros]="fieldErros('dt_end')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Prazo limite para prestação de contas: <sup class="text-danger">*</sup></label>
      <input type="text" id="days_accountability" class="form-control text-end" formControlName="days_accountability" (change)="changeDtSuspension($event)" />
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Data limite para prestação de contas:</label>
      <input class="form-control text-end" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_accountability" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" />
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor de repasse:</label>
      <input type="text" id="transfer_value" class="form-control text-end" formControlName="transfer_value" (keyup)="maskCurrency($event, 'transfer_value')" />
      <app-field-message [field]="fieldMessageRequired('transfer_value')" [erros]="fieldErros('transfer_value')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor de contrapartida:</label>
      <input type="text" id="counterpart_value" class="form-control text-end" formControlName="counterpart_value" (keyup)="maskCurrency($event, 'counterpart_value')" />
      <app-field-message [field]="fieldMessageRequired('counterpart_value')" [erros]="fieldErros('counterpart_value')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor de rendimento autorizado:</label>
      <input type="text" id="authorized_income_value" class="form-control text-end" formControlName="authorized_income_value" (keyup)="maskCurrency($event, 'authorized_income_value')" />
      <app-field-message [field]="fieldMessageRequired('authorized_income_value')" [erros]="fieldErros('authorized_income_value')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valor global:</label>
      <input id="global_value" class="form-control text-right" formControlName="global_value">
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-6 col-xl-6">
      <label class="col-sm-12 pb-1">Identificador: <sup class="text-danger">*</sup></label>
      <div class="d-flex" id="identifier">
        <ng-select id="identifier_type_id" class="ng-select-alternative" [items]="values_identifier_type_id" bindLabel="label" bindValue="id" placeholder="" formControlName="identifier_type_id">
        </ng-select>
        <input type="text" id="identifier_type_value" class="form-control text-end" formControlName="identifier_type_value" />
      </div>
        <app-field-message [field]="fieldMessageRequired('identifier_type_id')" [erros]="fieldErros('identifier_type_id')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Identificador no FPE:</label>
      <input type="text" id="fpe_identifier" class="form-control text-end" formControlName="fpe_identifier" />
      <app-field-message [field]="fieldMessageRequired('fpe_identifier')" [erros]="fieldErros('fpe_identifier')"></app-field-message>
    </div>
  </div>

  <div formArrayName="irfe_type">
    <div class="form-group row m-b" *ngFor="let item of getFormArray().controls; let i = index">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Tipo de Objeto</label>
        <ng-select id="irfe_type" class="ng-select-alternative" [items]="attrList?.irfe_type_list" bindLabel="label" bindValue="id" placeholder="Selecione o Tipo de Objeto" [formControlName]="i">
        </ng-select>
        <app-field-message [field]="fieldMessageRequireds('irfe_type', i)" [erros]="fieldErrosFormArray('irfe_type', i)"></app-field-message>
      </div>
      <button class="btn btn-danger col-sm-1 btn-remove" type="button" (click)="removeIrfeType(i)"><i class="fa fas fa-times"></i></button>
    </div>
  </div>
  <button class="btn btn-success btn-add-item m-b" type="button" (click)="addNewIrfeType()">Novo Tipo de Objeto</button>

  <div class="form-group row m-b">
    <div class="col-sm-6 col-xl-6">
      <label class="col-sm-12 pb-1">Modalidade de repasse: <sup class="text-danger">*</sup></label>
      <ng-select id="transfer_type_id" class="ng-select-alternative" [items]="values_transfer_type_id" bindLabel="label" bindValue="id" placeholder="" formControlName="transfer_type_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('transfer_type_id')" [erros]="fieldErros('transfer_type_id')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-6 col-xl-6">
      <label class="col-sm-12 pb-1">Tipo de transferência:</label>
      <ng-select id="transfer_type_id2" class="ng-select-alternative" [items]="values_transfer_type_id2" bindLabel="label" bindValue="id" placeholder="" formControlName="transfer_type_id2">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('transfer_type_id2')" [erros]="fieldErros('transfer_type_id2')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-6 col-xl-6">
      <label class="col-sm-12 pb-1">Status operacional: <sup class="text-danger">*</sup></label>
      <ng-select id="operational_status" class="ng-select-alternative" [items]="values_operational_status" bindLabel="label" bindValue="id" placeholder="" formControlName="operational_status_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('operational_status_id')" [erros]="fieldErros('operational_status_id')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-6 col-xl-6">
      <label class="col-sm-12 pb-1">Cláusula suspensiva?: <sup class="text-danger">*</sup></label>
      <ng-select id="values_suspension_clause" class="ng-select-alternative" [items]="values_suspension_clause" bindLabel="label" bindValue="id" placeholder="" formControlName="suspension_clause_id" (change)="changeSuspensionClause($event)">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('suspension_clause_id')" [erros]="fieldErros('suspension_clause_id')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b" *ngIf="isSuspensionClause">
    <div class="col-xs-12 col-md-5 col-lg-4 form-group mb-3">
      <label class="col-sm-12 pb-1">Data limite para retirada da suspensiva:</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_suspension" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }">
      <app-field-message [field]="fieldMessageRequired('dt_suspension')" [erros]="fieldErros('dt_suspension')"></app-field-message>
    </div>
  </div>
  <div class="list-info">
    <h4>Setorialista de Captação:</h4>
    <p>{{ sectorialist ?? 'Nenhum setorialista cadastrado no Órgão responsável pelo projeto' }}</p>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="this.entity?.id && this.permissions?.delete" (click)="confirmExcluir()" type="button">Excluir</button>      
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button *ngIf="canSave" class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>

<app-loading [loader]="isLoading"></app-loading>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<ng-container *ngIf="entity?.id">
  <app-aditivo-ircp-irfe-list [idIrfe]="entity?.id" [canSave]="canSave"></app-aditivo-ircp-irfe-list>
</ng-container>